import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import cineflicks from "../../Assets/Projects/cineflicks.png";
import face from "../../Assets/Projects/face.png";
import mobile from "../../Assets/Projects/mobile.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={face}
              isBlog={false}
              title="Face-Recognition-App"
              description="Built with precision using ReactJS and powered by TailwindCSS, my app seamlessly combines style and functionality for an immersive user experience. Leveraging API integration, it effortlessly fetches trending, new released, and upcoming movie and Tv shows data, providing comprehensive descriptions for every film."
              ghLink="https://github.com/AbdulHadi1010/movie-project"
              demoLink="https://cine-flicks.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cineflicks}
              isBlog={false}
              title="CineFlicks"
              description="Harnessing the power of ReactJS and TailwindCSS, I crafted a sleek face recognition app that's as visually appealing as it is functional. Seamlessly integrated with Clarifai's AI models through APIs, the app swiftly detects faces in images and delivers accurate results. Experience cutting-edge face recognition app!"
              ghLink="https://github.com/AbdulHadi1010/FaceRegWebApp"
              demoLink="https://face-recognition-app-sable.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mobile}
              isBlog={false}
              title="AccuWeatherSky"
              description="Leveraging React Native and seamless API integration, I designed a robust weather app that offers users detailed real-time weather data and a comprehensive 5-day forecast. Stay informed about current conditions and plan ahead with this intuitive and reliable application. "
              ghLink="https://github.com/AbdulHadi1010/My-Weather-App"
              demoLink="https://play.google.com/store/apps/details?id=com.myweatherapp"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
